<template>
    <div>
        <h2>Not found.</h2>
    </div>
</template>
<script>
export default {
    name: "NotFound",
}
</script>